import { shared } from '@shared/_lang/id';
import { autoinformer } from '@autoinformer/_lang/id';
import { autocaller_v2 } from '@autocaller_v2/_lang/id';
import { predictive_connect } from '@predictive_connect/_lang/id';
import { call_tracking } from '@call-tracking/_lang/id';
import { core } from '@core/_lang/id';
import { prices } from '@prices/_lang/id';
import { db } from '@db/_lang/id';
import { integration } from '@integration/_lang/id';
import { mailer } from '@mailer/_lang/id';
import { notify } from '@notify/_lang/id';
import { payment } from '@payment/_lang/id';
import { pbx } from '@pbx/_lang/id';
import { phone_number } from '@phone-number/_lang/id';
import { referral } from '@referral/_lang/id';
import { voice } from '@voice/_lang/id';
import { amoWidget } from '@amo-widget/_lang/id';
import { integrations } from '@integrations/_lang/id';
import { hlr } from '@hlr/_lang/id';


import { validator } from '@shared/_lang/id/validator';

export default {
  shared,
  autoinformer,
  autocaller_v2,
  predictive_connect,
  core,
  prices,
  db,
  integration,
  mailer,
  notify,
  payment,
  pbx,
  referral,
  voice,
  validator,
  amoWidget,
  integrations,
  hlr,
  'call-tracking': call_tracking,
  'phone-number': phone_number
};
